import { setSessionStorageItem } from '../../../../commons/utils';
import { SESSION_STORAGE_CURRENT_BOOKING } from '../../../../commons/constants';

export default (currentBookingVar) => {
  return (currentBooking) => {
    currentBookingVar(currentBooking);
    setSessionStorageItem(SESSION_STORAGE_CURRENT_BOOKING, currentBooking);
  };
};
